import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AxthenticationService } from '../../../services/axthentication.service';
import { ShareService } from '../../../services/share.service';
import { TxnService } from '../../../services/txn.service';
import { HttpService, StatusService } from 'ui-components/common';

/**
 * 	Ccmotview Service
 *
 * @author Benny
 * @version 1.0, 2017/09/11
 * @see
 * @since
 */
@Injectable({
    providedIn: 'root'
})
export class CcmotviewService extends TxnService {

    constructor(
        protected http: HttpService,
        protected shareService: ShareService,
        protected router: Router,
        protected axthenticationService: AxthenticationService,
        protected statusService: StatusService
    ) {
        super(http, shareService, router, axthenticationService, statusService);
        // console.log('CcmotviewService Init');
    }
}
